module.exports = __webpack_public_path__ + "img/tip2.6fe05e8f.png";